export interface PaginationMeta {
  current_page: number;
  total_pages: number;
  per_page: number;
  total_count: number;
}

export const PAGINATION_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

export function emptyPagination(perPage = 25): PaginationMeta {
  return {
    current_page: 1,
    total_pages: 0,
    per_page: perPage,
    total_count: 0,
  };
}

export class RequestSequencer {
  private latestId = 0;

  start() {
    const id = ++this.latestId;
    return {
      id,
      isCurrent: () => id === this.latestId,
    };
  }
}

export async function fetchJson<T>(
  url: string,
  init?: RequestInit
): Promise<{ ok: true; data: T } | { ok: false; status: number }> {
  const response = await fetch(url, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...init?.headers,
    },
  });

  if (!response.ok) {
    return { ok: false, status: response.status };
  }

  return { ok: true, data: await response.json() };
}
